<template>
  <div>
    <div class="title">个人中心</div>

    <div class="pass">
      <a-form-model ref="passFrom"
                  :model="pass"
                  :rules="passRules"
                  v-bind="layout"
                  >
        <a-form-model-item has-feedback  prop="userName" label="用户姓名：">
          <div style="margin-left: 12px;">{{ nickName }}</div>
        </a-form-model-item>
        <a-form-model-item has-feedback  prop="userName" label="用户账号：">
          <div style="margin-left: 12px;">{{ userName }}</div>
        </a-form-model-item>

        <a-form-model-item has-feedback prop="oldPassword" label="旧密码：">
          <a-input v-model="pass.oldPassword" placeholder="请输入旧密码" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback prop="newPassword" label="新密码：">
          <a-input v-model="pass.newPassword" placeholder="请输入新密码" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback prop="password" label="确定密码：">
          <a-input v-model="pass.password" placeholder="请输入确定密码" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item style="text-align: center">
          <a-button type="primary" @click="editPass('passFrom')">修改密码</a-button>
          <span style="width: 20px;height: 40px;display: inline-block"></span>
          <a-popconfirm
            title="确定退出登录吗？"
            ok-text="退出"
            cancel-text="取消"
            @confirm="logout()"
          >
            <a-button type="danger">退出登录</a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import cache from 'utils/cache';
import router, { resetRouter } from '@/router'
import { editPassword } from 'api/profile'
import { logout } from 'api/login'
import { isSsoMode, markSsoMode, clearSsoMode } from 'utils/sso'
export default {
  data() {
    let checkPending;
    let validateOldPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'));
      } else {
        callback();
      }
    };
    let validateNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else if(value === this.pass.oldPassword) {
         callback(new Error('新密码不能和旧密码一致'));
      } else if(value.length < 6) {
        callback(new Error('新密码不能少于6位数'));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确定密码'));
      } else if(value !== this.pass.newPassword) {
        callback(new Error('确定密码和新密码不一致'));
      } else {
        callback();
      }
    };
    return {
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      pass: {
        oldPassword: "",
        newPassword: "",
        password: ""
      },
      passRules: {
        oldPassword: [{ validator: validateOldPassword, trigger: 'change'}],
        newPassword: [{ validator: validateNewPassword, trigger: 'change'}],
        password: [{ validator: validatePassword, trigger: 'change'}],
      }
    }
  },
  mounted() {
    // console.log(cache.get("nickname"));
    // console.log(cache.get("id"));
    // console.log(cache.get("name"));
  },
  methods: {
    /**
    * 逻辑区
    */
    editPass(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.setEditPass(cache.get("id"), this.pass.oldPassword, this.pass.password)
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },

    /**
    * 接口区
    */
    setEditPass(id, oldPassword, password, smsCode, telephone) {
      editPassword(id, oldPassword, password, smsCode, telephone)
        .then(res => {
          console.log(res);
          if(res.message !=="success") {
            this.$message.error(res.message);
          } else {
            this.$message.success("密码修改成功！")
            cache.clear();
            this.$router.replace("/login")
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("修改失败，" + (err.message?err.message:'系统异常'));
        })
    },
    //退出登录
    logout() {
      logout()
        .then(res => {
          console.log(res);
          if(res.message !=="success") {
            this.$message.error(res.message);
          } else {
            this.$message.success("退出登录成功！")
            let isSSO = isSsoMode();
            cache.clear();
            resetRouter();
            if (isSSO){
              markSsoMode();
              this.$router.replace({
                path: "/auth"
              })
            }else {
              clearSsoMode();
              this.$router.replace({
                path: "/login"
              })
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("退出登录失败");
        })
    }

  },
  computed: {
    userName() {
      return cache.get("device-name")
    },
    nickName() {
      return cache.get("device-nickname")
    }
  }
}
</script>

<style lang='scss' scoped>
  .title {
    font-size: 30px;
    font-weight: 500;
    color: #131212;
  }
  .pass {
    width: 450px;
  }
</style>
